import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import {
  ClientRegisteredVendor,
  CompanyVendor,
  ExemptVendor,
  Vendor
} from 'src/app/classes/models';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-client-my-vendors-contacts',
  templateUrl: './client-my-vendor-contacts.component.html',
  styleUrls: ['./client-my-vendor-contacts.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientMyVendorContactsComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);

  constructor(
    private CompanyVendorService: CompanyVendorService,
    private route: ActivatedRoute,
    private ToastService: ToastService
  ) {}

  Vendor: Vendor | ClientRegisteredVendor | ExemptVendor | null = null;

  suppliedGridQueryData: {
    [key: string]: any;
  } = {
    attributes: ['id']
  };

  ngOnInit(): void {
    const paramMap: ParamMap = this.route.snapshot.paramMap;
    const VendorId = Number(paramMap.get('VendorId')) || null;
    const ExemptVendorId = Number(paramMap.get('ExemptVendorId')) || null;
    const ClientRegisteredVendorId =
      Number(paramMap.get('ClientRegisteredVendorId')) || null;
    const companyVendorQuery = {};
    const vendorQuery = {
      attributes: ['legalName']
    };

    if (VendorId) {
      Object.assign(this.suppliedGridQueryData, { VendorId });
      Object.assign(companyVendorQuery, {
        VendorId,
        Vendor: JSON.stringify(vendorQuery)
      });
    }

    if (ExemptVendorId) {
      Object.assign(this.suppliedGridQueryData, { ExemptVendorId });
      Object.assign(companyVendorQuery, {
        ExemptVendorId,
        ExemptVendor: JSON.stringify(vendorQuery)
      });
    }

    if (ClientRegisteredVendorId) {
      Object.assign(this.suppliedGridQueryData, { ClientRegisteredVendorId });
      Object.assign(companyVendorQuery, {
        ClientRegisteredVendorId,
        ClientRegisteredVendor: JSON.stringify(vendorQuery)
      });
    }

    this.CompanyVendorService.getCompanyVendor(companyVendorQuery).subscribe({
      next: (CompanyVendor: CompanyVendor) => {
        if (!CompanyVendor) {
          throw this.ToastService.addErrorToast(
            'Error',
            'No CompanyVendor Record found.',
            { returnError: true }
          );
        }

        const { Vendor, ExemptVendor, ClientRegisteredVendor } = CompanyVendor;

        if (Vendor) {
          this.Vendor = Vendor;
        }

        if (ExemptVendor) {
          this.Vendor = ExemptVendor;
        }

        if (ClientRegisteredVendor) {
          this.Vendor = ClientRegisteredVendor;
        }

        if (!this.Vendor) {
          throw this.ToastService.addErrorToast('Error', 'No Vendor Found.', {
            returnError: true
          });
        }
        this._cdr.markForCheck();
      }
    });
  }
}
